import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.qs-checks-rolle-berechtigungen-setzen';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksQsChecksRolleBerechtigungenSetzenEffects {

    QsChecksRolleBerechtigungenSetzen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_QS_CHECKS_ROLLE_BERECHTIGUNGEN_SETZEN),
        mergeMap((x: ac.PostQsChecksRolleBerechtigungenSetzenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postQsChecksRolleBerechtigungenSetzen(x.qsChecksRolleBerechtigungenRequest).pipe(
                map((result: any) => {
                    return new ac.PostQsChecksRolleBerechtigungenSetzenErfolgreichAction(result, x.qsChecksRolleBerechtigungenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostQsChecksRolleBerechtigungenSetzenFehlerAction(error, x.qsChecksRolleBerechtigungenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.RollenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.RollenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.RollenCommandService);
        }
        return this.service;
    }
}
